const Events = {
	HIDE_FOOTER: 'HIDE_FOOTER',
	SHOW_FOOTER: 'SHOW_FOOTER',
	MENU_INTERN: 'MENU_INTERN',
	MENU_HOME: 'MENU_HOME',
	LOGO_INTERN: 'LOGO_INTERN',
	LOGO_HOME: 'LOGO_HOME',
	OPEN_SERVICE: 'OPEN_SERVICE',
	CLOSE_SERVICE: 'CLOSE_SERVICE',
	SHOW_SCROLL_INTERN: 'SHOW_SCROLL_INTERN',
	SUCCESS_FORM: 'SUCCESS_FORM',
	CLOSE_SERVICE_REQUEST: 'CLOSE_SERVICE_REQUEST',
	GLOBAL_TRANSITION: 'GLOBAL_TRANSITION'
};

export { Events };
